/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Translation file for Spanish(Mexico) language
 *
 * @file es-mx.js
 * @author Manimaran.S
 */

const esmx = {
  'popularChannelSlider.allChannels': 'Todos los canales',
  'popularChannelSlider.recommended': 'Texto recomendado',
  'hero.myetextbook.link': 'biblioteca',
  'hero.myetextbook.text': '¿No es el título correcto? Abra su libro electrónico',
  'hero.etextfeaturestitle': 'Encuentre materiales de estudio en su libro de texto electrónico',
  'hero.etextfeaturesdescription': 'Su libro de texto electrónico viene con materiales de estudio diseñados para ayudarle a tener éxito. Estudie con tarjetas didácticas y más desde su libro de texto electrónico.',
  'aichat.title1': 'Obtenga ayuda potenciada por la IA sobre cualquier tema relacionado con este libro de texto electrónico',
  'aichat.chatDesc1': 'Escriba una pregunta para comenzar',
  'subscriptiontext.isSubscribed': 'Parte de su suscripción',
  'subscriptiontext.nonSubscriber': 'Actualizar para obtener el acceso total',
  'topicConatiner.otherHeader': 'Videos y prácticas relacionadas',
  'topicConatiner.exactLiteHeader': 'Conceptos y prácticas relacionadas',
  'moremenu.downloadApp': 'Descargar la aplicación',
  'moremenu.downloadAppAlreadyDownload': '%Click here% para descargar la aplicación en otro dispositivo e iniciar sesión automáticamente o para utilizar su código QR único para iniciar sesión de manera segura en la aplicación que instaló.',
  'moremenu.downloadAppNotDownload': '%Click here% para descargar la aplicación e iniciar sesión de manera segura con su código QR único',
  'channel.noBundletitle': 'Use Preparación de estudio para los cursos relacionados y otros',
  'onboard.studyPlan': 'Se creó el plan de estudio personalizado.',
  'onboard.addCourseAnother': '¿Quiere añadir otro curso?',
  'onboard.purchase': 'Necesito comprar un libro electrónico de Pearson',
  'onboard.addCourseWithoutEtext': 'Añadir curso con Preparación de estudio',
  'onboard.mayBeLater': 'Quizás luego',
  'onboard.aboutCourse': 'Cuéntenos sobre su curso',
  'onboard.close': 'Cerrar',
  'course.addTitle': 'Añadir curso',
  'common.PURCHASE': 'Comprar',
  'common.CLOSE': 'Cerrar',
  'open': 'abrir',
  'continue': 'Continuar',
  'yes': 'Sí',
  'no': 'No',
  'audio': 'Audio',
  'courses.toc.PUBLISH_SUCCESS': '¡Éxito!',
  'courses.toc.PUBLISH_MESSAGE': 'Los estudiantes verán sus cambios la próxima vez que abran el contenido.',
  'errors.GENERIC_TITLE': 'No tiene acceso por ahora',
  'errors.GENERIC_DESC': 'Primero, recargue o despeje su memoria caché. Si eso no funciona, comuníquese con asistencia ',
  'errors.GENERIC_LINK': 'de Pearson.',
  'errors.GENERIC_CODE': 'Código de error: {code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'No se encontró la suscripción.',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'Su cuenta no incluye acceso a este título. Si cree que recibió este mensaje por error, comuníquese con el soporte técnico de Pearson.',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'No se encontró la suscripción.',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'Su suscripción no incluye acceso al texto electrónico; sin embargo, puede suscribirse ahora mismo con una tarjeta de crédito.',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/?_ga=2.116082310.1845539610.1557867919-NimtqV7BcT00BM9xOXCQUFJYwF3RzEIk',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'Mi cuenta',
  'menu.helpCenter': 'Centro de asistencia',
  'menu.preferencesCenter': 'Centro de preferencias',
  'menu.CONTACT_SUPPORT': 'Comunicarse con soporte',
  'menu.HELP_SUPPORT': 'Ayuda y soporte',
  'menu.FAQS': 'Preguntas frecuentes',
  'menu.CHAT_WITH_SUPPORT': 'Hable con soporte técnico',
  'menu.OTP_CODES': 'Códigos de OTP',
  'menu.LAUNCH_CODE': 'Iniciar el registro de códigos',
  'menu.SEND_CODE': 'Enviar un código nuevo al usuario por correo electrónico',
  'menu.SEND_CODE_PHONE': 'Enviar un código nuevo al usuario por mensaje de texto',
  'menu.LEGAL': 'Legal',
  'menu.PRIVACY_NOTICE': 'Aviso de privacidad',
  'menu.TITLE_INFO': 'Información del título',
  'menu.PEARSON_ACCESSIBILITY': 'Accesibilidad Pearson',
  'menu.DEVICE_WARNING_MESSAGE': 'Registre {deviceLimit} dispositivos. Intercambie 1 al mes.',
  'menu.ACCESSIBILITY': 'Accesibilidad',
  'menu.ACCESSIBILITY_SUPPORT': 'Soporte de accesibilidad',
  'menu.DEVICES': 'Dispositivos recientes',
  'menu.THIS_DEVICE': 'Este dispositivo',
  'menu.GET_THE_APP_DOWNLOAD': 'Descargar la aplicación móvil',
  'menu.MOJO_APP_INFO': 'Visite la tienda de aplicaciones en su teléfono inteligente o tableta para usar Pearson+ sin conexión.',
  'menu.DEVICE_LABEL': 'Dispositivo',
  'menu.DEVICE_DISCONNECT': 'Desconectar',
  'menu.FOXIT': 'Activada por Foxit',
  'menu.TERMS_OF_USE': 'Términos de uso',
  'menu.SIGN_OUT': 'Cerrar sesión',
  'menu.PRINT_PAGE': 'Imprimir página',
  'menu.COPY_RIGHT': 'Copyright © {year} Pearson Education Inc. Todos los derechos reservados.',
  'print.FOOTER_MESSAGE': 'Impreso por {fullName}({email}) el {currentDate}.',
  'print.WATERMARK': 'Copyright © {year} Pearson Education',
  'device.SWAPPED_ALREADY': 'Ya ha hecho un intercambio este mes',
  'device.SWITCH_DEVICE': '¿Cambiar al dispositivo actual?',
  'device.SWITCH_ONCE': 'Dado que solo puede cambiar una vez al mes, no podrá deshacer esta acción.',
  'device.SEAT_TAKEN': 'Ese asiento está ocupado',
  'device.DISCONNECT_DEVICE': 'Solo puede iniciar sesión en 3 dispositivos. Para continuar aquí, desconecte otro dispositivo.',
  'device.ALERT_TEXT': 'Recuerde que solo puede cambiar los dispositivos una vez al mes.',
  'device.DISCONNECT': 'Desconectar',
  'device.CONTINUE': 'Continuar',
  'device.HEADER': '¿Desea cerrar su sesión en el otro navegador?',
  'device.CLOSE': 'Regresar a inicio',
  'device.CODE': 'Para continuar aquí, escriba el código de autenticación que le enviamos a {maskedEmail}. ¿No funciona? Revise su carpeta de correo basura, {email}, o comuníquese con {support}.',
  'device.TIMER': 'Tiene {time} para ingresar su código aquí',
  'device.RESEND': '{resend}',
  'device.FAQ': 'Preguntas frecuentes',
  'device.RESEND_NAME': 'Reenviar',
  'device.NOTE': 'Si usa Pearson+ en 2 lugares con regularidad, como en el trabajo y en casa, asegúrese de cerrar sesión cada vez que termine. También puede usar la aplicación móvil Pearson+ hasta en 2 dispositivos. Para ver más información, consulte nuestra sección de {faq}.',
  'device.NOTE_HEADER': 'Evite esto la próxima vez',
  'device.CONTACT_SUPPORT': 'Servicio de Asistencia al Cliente',
  'device.CONTACT_EMAIL': 'actualice su dirección de correo electrónico',
  'device.INCORRECT': 'Incorrecto: vuelva a verificar el código o solicite que se le reenvíe.',
  'device.MANY_ATTEMPTS': 'Realizó demasiados intentos, pruebe solicitar el reenvío del código',
  'device.EXPIRED': 'El tiempo ha expirado, pruebe solicitar el reenvío del código',
  'device.ACCESS_HEADER': '¡Ha ingresado!',
  'device.ACCESS_DESC': 'Su sesión se ha autenticado. ¿Quiere aprovechar a actualizar su contraseña?',
  'device.ACCESS_CHANGE_PASSWORD': 'Cambiar contraseña',
  'device.ACCESS_RESET_PASSWORD': 'Restablecer contraseña',
  'device.THREATONE_TITLE': '¿Está todo bien?',
  'device.THREATONE_DESC': '"Notamos una actividad sospechosa en su cuenta."',
  'device.THREATONE_DESC_TWO': 'Este es un buen momento para cambiar su contraseña.',
  'device.MAY_BE_LATER': 'Quizás luego',
  'device.OKAY': 'Okay',
  'device.ACCOUNT_LOCK_DESC': 'Por seguridad, cerraremos la sesión. Le enviamos un enlace de restablecimiento de contraseña al correo electrónico asociado con su cuenta.',
  'device.ACCOUNT_LOCK_TITLE': 'Notamos una actividad sospechosa en su cuenta',
  'device.ACCOUNT_LOCK_TIMER': 'La sesión se cerrará en {time}',
  'navigation.PAGE': 'Página',
  'launchcode.CREATEBY': 'Creado por:',
  'launchcode.sentvia': 'Enviado a través de:',
  'launchcode.CODEINLAST': 'Códigos de los últimos siete días:',
  'launchcode.TIMESENT': 'Hora de envío:',
  'launchcode.ACCOUNTEMAIL': 'Correo electrónico de la cuenta:',
  'launchcode.LAUNCHDIALOGTITLE': 'Registro de códigos de OTP',
  'textmessage.TITLE': 'Introducir número de teléfono',
  'textmessage.PHONE_NUMBER': 'Número de teléfono',
  'textmessage.SEND_CODE': 'Enviar código',
  'textmessage.INVALID_NUMBER': 'El número de teléfono móvil no es válido.',
  'textmessage.SUCCESS_MESSAGE': 'Código enviado',
  'remove.title': '¿Desea eliminar el título?',
  'remove.subTitle': 'Puede volver a recuperarlo más adelante, simplemente utilice la búsqueda para volver a agregarlo.',
  'remove.buttonText': 'Eliminar',
  'search.searchPlaceHolderPPlus': 'Buscar por ISBN, título o autor',
  'search.searchPlaceHolderEText': 'Busque en su biblioteca',
  'footer.downloadMobileApp': 'Descargar la aplicación móvil',
  'footer.termsOfUse': 'Términos de uso',
  'footer.privacy': 'Privacidad',
  'footer.cookies': 'Cookies',
  'footer.doNotSellMyPersonalInformation': 'No vendan mi información personal',
  'footer.accessibility': 'Accesibilidad',
  'footer.patentNotice': 'Aviso de patente',
  'footer.copyrights': 'Pearson Todos los derechos reservados.',
  'hero.toc.defaultPlacehoder': '--- seleccione un tema ---',
  'hero.openEtextBookV1': 'Abrir libro electrónico',
  'hero.heroHeading': 'Porque está estudiando <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': 'Preparación de estudio',
  'hero.study.help': 'Obtenga ayuda para el estudio',
  'hero.study.jumpBackIn': 'Volver a acceder',
  'hero.study.numOfUsers': 'Actualmente, <b>{num_of_users}</b> estudiantes están usando Canales.',
  'hero.heroChannel.cardsHeading': 'Continúe donde se haya quedado',
  'hero.marketingcard1.copy.title': 'Aprenda con videos',
  'hero.marketingcard1.copy.description': 'Vea videos explicativos breves en los que se analizan temas complicados.',
  'hero.marketingcard2.copy.title': 'Problemas de práctica',
  'hero.marketingcard2.copy.description': 'Prepárese para su examen con miles de preguntas de examen y videos con soluciones.',
  'hero.marketingcard3.copy.title': 'Obtenga ayuda experimentada',
  'hero.marketingcard3.copy.description': 'Publique preguntas y reciba respuestas de expertos en el tema.',
  'hero.popularTopics.heading': 'Otros temas populares de este canal',
  'hero.popularChannels.headingv1': '¿Está haciendo otro curso?',
  'hero.popularChannels.descriptionv2': 'Explore temas populares de ayuda con el estudio.',
  'hero.practice': 'Practicar',
  'hero.herobook.mappedChannelHeading': 'Ayuda con el estudio recomendada en este canal',
  'libraryL2.myBooks': 'Mis libros',
  'libraryL2.archived': 'Archivado',
  'libraryL2.back': 'Atrás',
  'hero.practiceProblem': 'Problema de práctica',
  'nativeAppBanner.drawer.title': 'Abrir en...',
  'nativeAppBanner.drawer.pearsonApp': 'Aplicación Pearson+',
  'nativeAppBanner.banner.title': 'Aplicación Pearson+',
  'nativeAppBanner.banner.description': 'Aprenda en cualquier lugar',
  'hero.promotionalcard.list1': 'Videos breves que explican temas complicados',
  'hero.promotionalcard.list2': 'Miles de preguntas similares a las del examen',
  'hero.promotionalcard.list3': 'Reciba respuestas de expertos en la materia',
  'hero.studyandexamprep': 'Preparación de estudio',
  'hero.heroBook.sectionSubHeadingV1': 'Analice temas difíciles con preguntas de práctica y explicaciones en video adaptadas a su curso.',
  'hero.heroBook.sectionSubHeadingV2': 'Analice temas difíciles con preguntas de práctica y explicaciones conceptuales adaptadas a su curso.',
  'hero.SeeAllStudyOptions': 'Ver todas las opciones de estudio',
  'hero.herobook.mappedChannelHeadingV1': 'Videos recomendados y preguntas de práctica',
  'hero.popularTopics.headingV1': 'Otros temas populares',
  'hero.heroHeadingV1': 'Para <span>{replace_value}</span>',
  'hero.learnmore': 'Leer más',
  'hero.eTextbook': 'Libro electrónico',
  'hero.goToPage.label': 'Ir a la página',
  'subscription.studyTitle': 'Preparación de estudio',
  'print.printAvailTitle': '¿Desea imprimir esta página? Haga lo siguiente.',
  'print.printAvailDesc': 'En su libro electrónico, seleccione el ícono de la cuenta en la parte superior derecha. En opciones, elija "Imprimir página" y luego elija la configuración de impresión deseada.',
  'print.printNotAvailTitle': 'La opción para imprimir este libro de texto electrónico no está habilitada.',
  'print.printNotAvailDesc': 'Para tener acceso conveniente sin internet, descargue su título por medio de la aplicación móvil Pearson+ ¡y disfrute de la flexibilidad de estudiar en cualquier momento y lugar!',
  'hero.header.cta': 'Ir a herramientas de estudio',
  'hero.header.ctav2': 'Abrir Preparación de estudio',
  'hero.marketing.title': 'Encuentre su libro electrónico',
  'hero.marketing.subTitle': 'Elija entre más de 2000 libros electrónicos de texto con audio, tarjetas didácticas, notas y más. A solo $10.99 al mes por un periodo de 4 meses.',
  'hero.popularchannels.desc': 'Obtenga ayuda para el estudio con estos temas principales',
  'hero.removecourse.title': '¿Desea eliminar el curso del panel?',
  'hero.removecourse.description': 'Siempre puede añadir este curso de nuevo al panel. Para ello, haga clic en "Añadir curso".',
  'hero.removecourse.primaryCtaText': 'Eliminar',
  'hero.removecourse.secondaryCtaText': 'CANCELAR',
  'hero.tableOfContents': 'Índice',
  'hero.search': 'Buscar',
  'hero.emptystate.cta': 'Buscar libros de texto electrónicos',
  'hero.watch_it_again': 'Vuelva a verlo',
  'hero.mondly.learnLang.title': 'Aprenda un nuevo idioma gratis',
  'hero.mondly.subTitle': 'Los usuarios de libros de texto electrónicos de Pearson obtienen tres meses gratis de Mondly de Pearson.',
  'hero.mondly.description': 'La mayoría de las aplicaciones para aprender idiomas solo permiten aprender desde el inglés. Sin embargo, lo mejor es aprender desde su lengua materna; por eso, Mondly le permite aprender desde cualquiera de nuestros <strong>41 idiomas</strong>.',
  'hero.mondly.startLearningCTA': 'Comenzar a aprender',
  'hero.mondly.marketing.bestApp': 'Mejor aplicación',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': 'Aplicación del año',
  'hero.mondly.marketing.fbStart': 'Ganadora de Facebook FbStart - EMEA 2017',
  'hero.mondly.marketing.editorChoice': 'Elección del editor',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'Aprenda un idioma',
  'header.menu.moreAtPearson': 'Más en Pearson',
  'hero.subscriptionStatusTitle2': 'Sus recursos de Pearson+',
  'hero.startStudying': 'Comenzar a estudiar',
  'onboard.studyMaterials': 'Seleccione su materia y crearemos un tablero con material de estudio personalizado.',
  'hero.myETextbooks': 'Mis libros electrónicos',
  'header.continueInTheApp': 'Continuar en la aplicación',
  'hero.learnTxt': 'Aprender',
  'hero.examPrepTxt': 'Preparación para exámenes',
  'hero.aITutorTxt': 'Tutor con IA',
  'AI.toolTip': 'Pregúnteme sobre cualquier tema dentro de su libro de texto electrónico',
  'hero.studyExamPrepAllYourCourses': 'Preparación de estudio para todos sus cursos',
  'header.qrCode.subHeaderTxt': 'Utilice este código QR para iniciar sesión en la aplicación Pearson+ de manera rápida y segura en su dispositivo móvil.',
  'header.qrCode.dontHaveApp': '¿No tiene la aplicación?',
  'header.qrCode.footerTxt': 'Escanee este código para ir a la App Store o a Google Play. Una vez que descargue la aplicación, inicie sesión volviendo a escanear el código.',
  'header.qrCode.errorMsg': 'No se cargó el código QR. Cierre e intente nuevamente.',
  'hero.yourETextbook': 'Su libro de texto electrónico',
  'onboard.addCourseWithEtextBundle': 'Añadir curso con Preparación de estudio',
  'onboard.disableTooltipText': 'Se añadieron todos los cursos de Preparación de estudio',
  'subscriptionstatus.bundlecta': 'Acceder a Preparación de estudio',
  'subscriptionstatus.nonbundlecta': 'Acceder a Preparación de estudio',
  'channel.genericBundle': 'Use Preparación de estudio como apoyo para sus otros cursos',
  'channel.relatedBundle': 'Use Preparación de estudio como apoyo para sus otros cursos',
  'onboard.courseAdded': 'Se añadió el curso.',
  'hero.flashcards': 'Tarjetas didácticas',
  'relatedChannelCard.title': 'Mejore su aprendizaje con este recurso relacionado',
  'relatedChannelCard.badgeText': 'Preparación de estudio relacionado',
  'sessionInactivity.title': '¿Se encuentra ahí?',
  'sessionInactivity.description': 'Su sesión expira en <b>%TIMER%</b> por inactividad.<br/>¿Desea mantener la sesión abierta?',
  'sessionInactivity.keepMeSignIn': 'Seguir conectado',
  'sessionInactivity.signOut': 'Cerrar sesión',
  'sessionTimeout.title': 'La sesión expiró',
  'sessionTimeout.description': 'La sesión expiró por inactividad.',
  'print.qrCode.header': 'Utilice este código QR para abrir la aplicación Pearson+ en su dispositivo móvil.',
  'print.qrCode.footer': 'Escanee este código para ir a la App Store o a Google Play. Una vez que instale la aplicación, inicie sesión para descargar y tener acceso a su título.',
  'hero.nestest.title': 'Prepárese para su examen de certificación como maestro',
  'hero.nestest.subTitle': 'Los usuarios de Pearson+ ya pueden acceder a cursos de preparación y exámenes de práctica con alineación nacional para prepararse para sus exámenes de certificación como maestros.',
  'hero.channelAI.title': '¿Necesita ayuda? El tutor con IA tiene la respuesta.',
  'hero.channelAI.desc': 'Haga una pregunta y obtenga ayuda para su tarea paso a paso, recomendaciones de estudio y más. Obtenga ayuda personalizada siempre que lo necesite.',
  'hero.channelAI.action': 'Preguntar al tutor con IA',
  'new': '¡Nuevo!',
  'hero.practice.numOfUsers': 'Esta sección tiene <b>{practice_num_of_users}</b> problemas de práctica.',
  'hero.practice.cta': 'Practique ahora',
  'hero.practice.title': 'Problema de práctica',
  'diagnostics.errorMsg': 'No se cargó el diagnóstico. Cierre e intente nuevamente.',
  'qrcode.title': 'Empiece a estudiar en cualquier lugar',
  'qrcode.subtitle': 'Aprenda en cualquier momento y lugar con la aplicación móvil Pearson+. Descárguela ahora y obtenga una experiencia didáctica completa.',
  'qrcode.detailsv1': 'Con la aplicación Pearson+, puede usar este código QR para continuar en donde se quedó. Busque en su libro, estudie con tarjetas didácticas, vea lecciones en video y más, en cualquier lugar.',
  'qrcode.detailsv2': 'Escanee este código QR siempre que quiera iniciar sesión con rapidez y continuar en donde se quedó.',
  'qrcode.details': 'Con la aplicación Pearson+, puede usar este código QR para continuar en donde se quedó.',
  'qrcode.appstore': 'App Store',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': 'Aprenda en cualquier momento y lugar con la aplicación móvil Pearson+. Descárguela ahora y obtenga una experiencia didáctica completa.',
  'install': 'Install',
  'header.menu.createCourse': 'Nuevo curso',
  'header.dropdown.courses': 'Cursos',
  'header.dropdown.recentlyViewed': 'Visto recientemente',
  'header.dropdown.viewAll': 'Ver todos los cursos',
  'aet.courseHeader.inviteStudents': 'Invitar estudiantes',
  'aet.courseHeader.inviteStudentModal.subTitle': 'Para invitar estudiantes a acceder a este libro de texto electrónico, copie la dirección del enlace o las instrucciones siguientes en su correo electrónico o temario.',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'Dirección del enlace',
  'aet.courseHeader.inviteStudentModal.copyLink': 'Copiar enlace',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'Instrucciones con la dirección del enlace',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'Copiar instrucciones',
  'aet.courseHeader.inviteStudentModal.instructionIntro': 'It\'s time to access {bookTitle} the eTextbook for {courseName}.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'When you\'re ready, access your eTextbook at: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'Se le pedirá que inicie sesión con su cuenta actual de Pearson. Si no tiene una cuenta de Pearson, podrá crear una.  ',
  'aet.courseHeader.inviteStudentModal.instructionHelp': 'Need help? ',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'Fecha de inicio:',
  'aet.courseHeader.endDate': 'Fecha de finalización:',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'Formato:',
  'aet.home.manageroster': 'Administrar lista',
  'aet.home.managegradesync': 'Administrar sincronización de calificaciones',
  'aet.home.copycourse': 'Copiar curso',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.instructorCourse.tabs.current': 'Actual',
  'aet.instructorCourse.tabs.past': 'Pasado',
  'aet.instructorCourse.tabs.courseSettings': 'Configuración del curso',
  'aet.instructorCourse.tabs.manageRoster': 'Administrar lista',
  'aet.instructorCourse.currentCourses.title': 'Cursos actuales',
  'aet.instructorCourse.pastCourses.title': 'Cursos pasados',
  'aet.instructorCourse.createOrCopy.title': 'Crear o copiar curso',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'Copiar el curso de otro instructor o crear uno nuevo',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'Copiar el curso de otro instructor',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'Escriba el identificador de curso para encontrar el curso que desea copiar.',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'Identificador del curso',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'Escriba el identificador del curso',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'Usted buscó',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'Crear un curso nuevo del catálogo',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'Buscar por título, autor, ISBN o palabras clave de la materia',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'Buscar...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'Mostrar más',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'Mostrar menos',
  'aet.instructorCourse.cancel': 'CANCELAR',
  'aet.instructorCourse.loading': 'Cargando...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'Sincronizar calificaciones',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'Administrar sincronización de calificaciones',
  'aet.instructorCourse.courseForm.courseNameLabel': 'Nombre del curso',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'Sin título',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'Nombre de la sección',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'Sin título',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'Institución',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'La institución es obligatoria',
  'aet.instructorCourse.courseForm.institutionSearchError': 'Algo salió mal. Inténtelo de nuevo.',
  'aet.instructorCourse.courseForm.institutionNoResults': 'No hay resultados',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another Institution',
  'aet.instructorCourse.courseForm.startDateLabel': 'Fecha de inicio del curso',
  'aet.instructorCourse.courseForm.endDateLabel': 'Fecha de finalización del curso',
  'aet.instructorCourse.courseForm.datePlaceholder': 'dd/mm/aa',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'Permitir que otros copien este curso',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'Comparta este código con los instructores que quieran copiar este curso',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'Copiar código',
  'aet.instructorCourse.courseForm.optionalSuffix': '(opcional)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'El formulario tiene errores de validación',
  'aet.instructorCourse.courseForm.submitContinue': 'Continuar',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'Guardando...',
  'aet.instructorCourse.courseForm.submitError': 'No pudimos crear su curso. Inténtelo de nuevo.',
  'aet.instructorCourse.courseForm.submitEditError': 'No pudimos guardar sus cambios. Inténtelo de nuevo.',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'Guardar cambios',
  'aet.instructorCourse.courseForm.materialsHeader': 'Materiales del curso',
  'aet.instructorCourse.courseForm.resolveError': 'No pudimos cargar los materiales del curso. Inténtelo de nuevo.',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'Últimos vistos',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'Agregado recientemente',
  'aet.instructorCourse.coursesSort.aToZ': 'De la A a la Z',
  'aet.instructorCourse.coursesSort.zToA': 'De la Z a la A',
  'aet.instructorCourse.manageRoster.column.name': 'Nombre',
  'aet.instructorCourse.manageRoster.column.role': 'Función',
  'aet.instructorCourse.manageRoster.column.email': 'Correo electrónico',
  'aet.instructorCourse.manageRoster.column.status': 'Estado',
  'aet.instructorCourse.manageRoster.enrolledDate': 'Enrolled {date}',
  'aet.instructorCourse.manageRoster.notAvailable': '--',
  'aet.instructorCourse.roster.role.student': 'Alumno',
  'aet.instructorCourse.roster.role.ta': 'Maestro asistente',
  'aet.instructorCourse.roster.role.instructor': 'Instructor',
  'aet.instructorCourse.roster.status.active': 'Activo',
  'aet.instructorCourse.roster.status.inactive': 'Inactivo',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'Todos los miembros',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'Estudiantes activos',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'Estudiantes inactivos',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'Maestro asistente',
  'aet.instructorCourse.manageRoster.filter.instructor': 'Instructor',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'Autor:',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN:',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'Fecha de creación del curso:',
  'aet.instructorCourse.noCoursesFound': 'No se encontraron cursos',
  'aet.instructorCourse.backButton': 'Atrás',
  'aet.instructorCourse.selectCourse': 'Seleccionar curso',
  'aet.home.linkedToLms': 'Enlazado con el LMS',
  'aet.instructorCourse.courseForm.title.create': 'Crear curso',
  'aet.instructorCourse.courseForm.title.copy': 'Copiar curso',
  'aet.instructorCourse.courseForm.title.edit': 'Información del curso',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.title': 'Asignaciones',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.content': 'Contenido de la asignación',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.dueDates': 'Fechas de entrega de asignaciones',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.title': 'Puntos destacados y notas',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.highlightColor': 'Color de resaltado',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.noteText': 'Texto de nota',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.sharedStatus': 'Estado para compartir',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.title': 'Lista de estudiantes y participación',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.studentNames': 'Nombres de los estudiantes',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.emailAddresses': 'Direcciones de correo electrónico',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.enrollments': 'Inscripciones',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.completionAndInsights': 'Conclusión e ideas',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'Configuración',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.aiToolEnablement': 'AI Tool enablement',
  'aet.instructorCourse.courseForm.copyAccordionTitle': 'Show what’s copied',
  'aet.instructorCourse.courseForm.copyAccordionSubTitle': 'Datos copiados',
  'aet.studentRoster.manageStudentRosterButton': 'Administrar lista de estudiantes',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.assignments.exportStudentProgressButton': 'Exportar progreso de los estudiantes',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'Estado:',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'Inscrito:',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'Función:',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': 'Promote  {studentName} ?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'Como maestro asistente, esta persona podrá ver el progreso y desempeño de todos los estudiantes de la clase.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'También podrá administrar estudiantes y asignaciones, pero no podrá borrar el grupo.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'Promover a maestro asistente',
  'aet.home.manageRoster.searchPlaceholder': 'Buscar un estudiante',
  'aet.home.manageRoster.inactivateButtonLabel': 'Desactivar a los estudiantes seleccionados',
  'aet.home.manageRoster.FilterLabel': 'Show',
  'aet.home.manageRoster.updatingMessage': 'Actualizando lista... Esto puede tomar varios minutos.',
  'aet.home.courses.search.searchPlaceHolder': 'Buscar sus cursos',
  'aet.courses.emptyStateDescription': 'Para empezar a construir su curso, seleccione una de las opciones siguientes.',
  'nativePromoBanner.continueInBrowser': 'Continuar en el navegador',
  'globalnav.tooltip.hideNavText': 'Ocultar navegación',
  'globalnav.tooltip.showNavText': 'Mostrar navegación',
  'aet.syllabus.progressTitle': 'Extrayendo...',
  'aet.syllabus.progressDesc': 'Por favor espere mientras procesamos su temario.',
  'aet.syllabus.uploadInputLabel': 'Arrastre y suelte archivos o haga clic para cargarlos',
  'aet.syllabus.uploadSyllabusTabLabel': 'Cargar temario',
  'aet.syllabus.dateAdjusterTabLabel': 'Ajustador de fecha',
  'aet.syllabus.addManuallyTabLabel': 'Añadir manualmente',
  'aet.syllabus.addEditLaterText': 'Usted siempre puede añadir y editar las asignaciones después',
  'aet.syllabus.editAssignmentLabel': 'Editar asignación',
  'aet.syllabus.addAssignmentLabel': 'Añadir asignación',
  'aet.syllabus.assignmentTitleLabel': 'Título de la asignación',
  'aet.syllabus.dueDateLabel': 'Fecha de entrega',
  'aet.syllabus.editDueDateLabel': 'Editar fecha de entrega',
  'aet.syllabus.chaptersCoveredLabel': 'Seleccione los capítulos o las secciones a cubrir',
  'aet.syllabus.updateCtaLabel': 'Actualizar asignación',
  'aet.syllabus.addCtaLabel': 'Añadir asignación',
  'aet.syllabus.uploadLabel': 'Cargar',
  'aet.syllabus.confirmLabel': 'Confirmar',
  'aet.syllabus.updateDatesLabel': 'Actualizar fecha',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'Your due date was updated. Review it, then publish.',
  'aet.syllabus.coverageDedupe.adjustedContent': 'Your chapter/section information was updated. Review it, then publish.',
  'aet.syllabus.unassignedCoverageStatus': 'Some chapters are not assigned yet. Assign them before you publish.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.deleteAssignmentTitle': '¿Eliminar asignación?',
  'aet.deleteAssignmentTitleMultiple': '¿Eliminar asignaciones?',
  'aet.deleteAssignmentWarning': 'Esta acción no puede deshacerse, y todos los envíos y datos de estudiantes asociados ya no serán visibles.',
  'aet.deleteAssignmentKeepCTA': 'Conservar asignación',
  'aet.deleteAssignmentDeleteCTA': 'ELIMINAR',
  'aet.assignments.loadingAsset': 'Cargando recurso...',
  'aet.assignments.allCaughtUpDescription': 'No tiene asignaciones pendientes esta semana.',
  'aet.assignments.progressTitle': 'Progreso',
  'aet.assignments.performanceTitle': 'Confianza',
  'aet.assignments.completionTitle': 'Conclusión',
  'aet.assignments.statusTitle': 'Estado',
  'aet.assignments.addTooltip': 'Añadir asignación',
  'aet.assignments.deleteTooltip': 'Eliminar asignaciones seleccionadas',
  'aet.assignments.selectToDeleteLabel': 'Modo de seleccionar y eliminar',
  'aet.assignments.bulkEditTooltip': 'Editar asignaciones en bloque',
  'aet.assignments.title': 'Asignaciones',
  'aet.assignments.assignmentTitle': 'Tarea',
  'aet.assignments.dueDate': 'Fecha de entrega',
  'aet.tabular.searchPlaceholder.assignments': 'Buscar asignaciones',
  'aet.tabular.searchPlaceholder.students': 'Buscar estudiantes',
  'aet.tabular.searchPlaceholder.questions': 'Buscar preguntas',
  'aet.assignemnts.columnDueDateInfoTooltip': 'Uno o más estudiantes tienen prórrogas en las fechas de entrega de todas las asignaciones',
  'aet.assignemnts.singleDueDateInfoTooltip': 'Uno o más estudiantes tienen prórrogas en las fechas de entrega de esta asignación',
  'aet.assignemnts.masterDueDateInfoTooltip': 'Uno o más estudiantes han recibido prórrogas en las fechas de entrega. Busque el ícono de Información para identificar en cuáles asignaciones.',
  'aet.home.loading': 'Cargando...',
  'aet.home.errorFetchingAssignments': 'Error al obtener las asignaciones',
  'aet.home.dueThisWeekTitle': 'Se entrega esta semana',
  'aet.home.allCaughtUpTitle': '¡Ya está al corriente!',
  'aet.home.allCaughtUpDescription': 'No tiene asignaciones pendientes esta semana.',
  'aet.home.suggestedRemediationTitle': 'Revisión sugerida por Preparación de estudio',
  'aet.home.noSuggestedRemediationTitle': 'No hay material de revisión sugerido',
  'aet.home.noSuggestedRemediationDescription': 'Vuelva a revisar después de su siguiente asignación.',
  'aet.home.assignmentIncludesTitle': 'La asignación incluye',
  'aet.home.sectionsLabel': 'Capítulo(s)',
  'aet.home.questionsCount': '{count} preguntas',
  'aet.home.dueLabel': 'Fecha de entrega: {dueDate}',
  'aet.home.due': 'Fecha de entrega:',
  'aet.home.progressCompletedLabel': 'Terminado',
  'aet.home.progressCompletedPastDueLabel': 'Terminado con retraso',
  'aet.home.progressInProgressLabel': 'En proceso',
  'aet.home.progressNotStartedLabel': 'No iniciado',
  'aet.home.progressCountOfTotal': '{count} de {total}',
  'aet.home.NotAttemptedLabel': 'No intentado',
  'aet.home.questionsTotalLabel': 'Total de preguntas',
  'aet.home.progressCompletedOnTimeLabel': 'Terminado a tiempo',
  'aet.home.segmentGreatLabel': 'Excelente',
  'aet.home.segmentGettingThereLabel': 'Okay',
  'aet.home.segmentNeedsReviewLabel': 'Necesita mejorar',
  'aet.home.segmentOkayLabel': 'Okay',
  'aet.home.editAssignmentTooltip': 'Editar asignación',
  'aet.home.deleteAssignmentTooltip': 'Eliminar asignación',
  'aet.home.viewDetailsButton': 'Ver detalles',
  'aet.home.viewAsStudentButton': 'Ver como estudiante',
  'aet.home.welcomeButtonText': 'Comenzar →',
  'aet.review.emptyStateTitle': 'No hay nada que repasar.',
  'aet.review.emptyStateDescription': 'Vuelva a revisar después de su siguiente asignación.',
  'aet.dashboard.tabs.upNext': 'A continuación',
  'aet.dashboard.tabs.welcome': 'Bienvenido',
  'aet.dashboard.tabs.assignments': 'Asignaciones',
  'aet.dashboard.tabs.review': 'Revisar',
  'aet.dashboard.tabs.studentRoster': 'Estudiantes',
  'aet.dashboard.classSchedule': 'Horario de clase:',
  'aet.syllabus.dueTimeLabel': 'Hora de entrega',
  'hero.accessEducatorGuides': 'Acceder a guías del educador',
  'aet.assignment.save': 'Guardar',
  'aet.assignment.saveAndAdd': 'Guardar y añadir otro',
  'aet.assignment.delete': 'ELIMINAR',
  'aet.assignment.saveAndClose': 'Guardar y cerrar',
  'aet.studentRoster.title': 'Estudiantes',
  'aet.studentRoster.titlev1': 'Alumno',
  'aet.studentRoster.dueDatesAdjustmentLabel': 'Fechas de entrega',
  'aet.studentRoster.dueDateAdjustment.option.0': 'Estándar',
  'aet.studentRoster.dueDateAdjustment.option.2': '+2 días',
  'aet.studentRoster.dueDateAdjustment.option.3': '+3 días',
  'aet.studentRoster.dueDateAdjustment.option.5': '+5 días',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '+1 semana',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '+2 semanas',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': 'Ultimo día de clases',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count} asignaciones actualizadas',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': 'Las asignaciones vencidas no pudieron actualizarse automáticamente. Edite cada una para establecer una nueva fecha de entrega.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': 'No se pueden actualizar las fechas de entrega',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'Todas las asignaciones están vencidas y no pudieron actualizarse automáticamente. Edite cada una para establecer una nueva fecha de entrega.',
  'aet.bulkEdit.bulkSplitInstruction': 'Dividiremos sus asignaciones de forma uniforme.',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer. Editor library device auto star reesizing pencil horizontal. Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': 'Fecha de entrega de la primera asignación',
  'aet.bulkEdit.lastAssignmentDue': 'Fecha de entrega de la última asignación',
  'aet.bulkEdit.assignmentsDueDays': '¿En que días desea que sean las entregas de las asignaciones?',
  'aet.bulkEdit.addEditLaterText': 'Usamos IA para crear asignaciones. Usted siempre puede añadir y editar las asignaciones después.',
  'aet.bulkEdit.monday': 'Lunes',
  'aet.bulkEdit.tuesday': 'Martes',
  'aet.bulkEdit.wednesday': 'Miércoles',
  'aet.bulkEdit.thursday': 'Jueves',
  'aet.bulkEdit.friday': 'Viernes',
  'aet.bulkEdit.saturday': 'Sábado',
  'aet.bulkEdit.sunday': 'Domingo',
  'aet.toast.assignmentCreated.title': '¡Asignación creada!',
  'aet.toast.assignmentCreated.single': 'Se le asignó automáticamente el nombre {assignmentTitle}',
  'aet.toast.assignmentCreated.multiple': '{count} asignaciones creadas',
  'aet.toast.assignmentUpdated.title': 'Actualizado correctamente.',
  'aet.toast.assignmentUpdated.single': '{assignmentTitle} se ha actualizado',
  'aet.toast.assignmentUpdated.multiple': '{count} asignaciones han sido actualizadas',
  'aet.toast.viewAssignment': 'Ver asignación',
  'aet.toast.viewAssignments': 'Ver asignaciones',
  'aet.welcome.title': 'Su libro de texto electrónico de Pearson ya está vinculado con su curso del LMS',
  'aet.welcome.LMSAccounTitle': 'Explore información de los estudiantes',
  'aet.welcome.LMSAccounDescription': 'Vea exactamente con qué temas tiene problemas su grupo.',
  'aet.welcome.createAssignmentsTitle': 'Crear asignaciones',
  'aet.welcome.createAssignmentsDescription': 'Asigne capítulos manualmente o cargando su plan de estudios.',
  'aet.welcome.progressViewTitle': 'Haga seguimiento del desempeño en su LMS',
  'aet.welcome.progressViewDescription': 'Elija ajustes de sincronización de calificaciones en su curso del LMS.',
  'aet.assignmentDetails.noAssignmentFound': 'No se encontró la asignación',
  'aet.assignments.loadingErrorTitle': 'La asignación no puede cargarse por ahora',
  'aet.assignments.loadingErrorDescription': 'Trate de recargar la página o vuelva a consultar más tarde.',
  'aet.assignmentStudentDetails.noDataFound': 'Aún no hay datos',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'No hay estudiantes inscritos',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'Los estudiantes se unirán a su grupo cuando compren el libro de texto electrónico.',
  'aet.home.editAssignmentTooltipDisabled': 'No puede editarse: el trabajo del estudiante está en curso',
  'aet.home.deleteAssignmentTooltipDisabled': 'No puede eliminarse: el trabajo del estudiante está en curso',
  'aet.home.StudentDetails.questions': 'Preguntas',
  'aet.home.StudentDetails.attempts': 'Intentos',
  'aet.home.StudentDetails.comprehension': 'Confianza',
  'hero.titleInfo.tooltip': 'Información del título',
  'aet.home.publishAssignments': 'Publicar todas las asignaciones',
  'aet.dashboard.footer': 'Alguna parte del contenido es creado con IA en función del material de aprendizaje de Pearson. Aunque Pearson cuenta con un proceso para validar el resultado, es posible que la IA generativa produzca información inexacta sobre personas, lugares o hechos.',
  'aet.home.bulkEditTitle': 'Editar asignaciones en bloque',
  'aet.home.bulkEditSubtitle': 'Haga sus cambios a su temario, y vuelva a cargarlo aquí. Sus asignaciones y fechas de entrega se cambiarán en consecuencia.',
  'aet.home.createAssignmentTitle': 'Crear asignaciones',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'Incluido en otra asignación',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'Algunas secciones se incluyen en otra asignación',
  'aet.welcome.welcome.Title': '¡Bienvenido!',
  'aet.home.student.roaster.ProgressTitle': 'Avance total',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'Vuelva a consultar cuando los estudiantes inicien la asignación.',
  'aet.home.whatDueThisWeekTitle': 'Estos son los pendientes de esta semana',
  'aet.assignments.edit.errorTitle': '{count} asignaciones tienen errores',
  'aet.assignments.edit.errorSubTitle': 'Las asignaciones con errores no pueden publicarse. Edítelas o publíquelas sin ellos.',
  'aet.assignments.edit.publishAnyway': 'Publicar de cualquier modo',
  'aet.assignments.edit.editAssignments': 'Editar asignaciones',
  'aet.assignments.edit.validationInfoToolTip': 'Editar asignación para eliminar errores',
  'aet.assignments.error.assignmentCreated.title': 'Todas las asignaciones tienen errores',
  'aet.assignments.error.assignmentCreated.description': 'Las asignaciones con errores no pueden publicarse. Edítelas o pruebe con un temario diferente.',
  'aet.assignments.error.uploadSyllabus': 'Cargar temario',
  'aet.assignments.error.editAssignments': 'Editar asignaciones',
  'aet.mondly.title': 'Idiomas',
  'aet.studentRoster.errorState.title': 'Lista de estudiantes no disponible',
  'aet.studentRoster.errorState.description': 'No pudimos cargar su lista de estudiantes. Trate de recargar la página o vuelva a consultar más tarde.',
  'aet.assignments.sectionLabel': 'sección(es)',
  'aet.assignments.questionsLabel': 'pregunta(s)',
  'aet.assignments.assignmentsLabel': 'asignación(es)',
  'aet.assignments.performanceProgressBar': 'Barra de progreso del desempeño',
  'aet.assignments.completionProgressBar': 'Barra de progreso del avance',
  'aet.syllabus.deleteConfirmationSubtitleSingle': '¿Está seguro de que desea eliminar esta asignación?',
  'aet.syllabus.deleteConfirmationSubtitleBulk': '¿Está seguro de que desea eliminar estas asignaciones?',
  'aet.home.nextAssignmentTitle': 'Siguiente asignación',
  'aet.home.courseSettings': 'Configuración del curso',
  'aet.home.pearsonETextbookResources': 'Recursos de libros de texto electrónicos de Pearson+',
  'aet.home.etextbookInformation': 'Información sobre el libro de texto electrónico',
  'aet.multiple.deleteAssignmentKeepCTA': 'Conservar asignación(es)',
  'aet.syllabus.processingText.header': 'Estamos organizando las lecturas asignadas para su clase – esto tomará solo un momento.',
  'aet.syllabus.processingText.uploading': 'Cargando su documento',
  'aet.syllabus.processingText.activating': 'Activando componentes de IA',
  'aet.syllabus.processingText.extracting': 'Extrayendo las lecturas asignadas',
  'aet.syllabus.processingText.mapping': 'Relacionando con el contenido del libro de texto',
  'aet.syllabus.processingText.finishing': 'Terminando',
  'aet.syllabus.uploadErrorMessage': 'Asegúrese de que su archivo PDF o .docx sea menor a 10 MB y que su conexión a internet sea estable',
  'aet.syllabus.uploadNoAssignmentsMessage': 'No reading assignments found',
  'aet.syllabus.uploadNoAssignmentsDescription': 'We could not pull reading assignments from this file. You can add them manually.',
  'aet.syllabus.uploadFailedRetryCTA': 'Inténtelo de nuevo',
  'aet.syllabus.selectChapterWithQuestions': 'Seleccione un capítulo con preguntas.',
  'preferenceSetting.subTitle': 'Estos ajustes serán los predeterminados para todos los estudiantes de este curso.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'Interacciones con IA',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'Habilitar la herramienta de estudio con IA y los resúmenes de IA en los resultados de búsquedas',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'Mostrar los recursos de preparación de estudio relacionados con este libro',
  'aet.syllabus.footer': 'La elaboración de asignaciones se realiza con IA',
  'aet.dashboard.footerDialogDeatils': 'Se utiliza IA generativa para elaborar preguntas de las asignaciones con base en el material de aprendizaje de Pearson. Aunque Pearson cuenta con un proceso para validar el resultado, es posible que la IA generativa produzca información inexacta sobre personas, lugares o hechos. También se utiliza IA para agrupar el contenido en asignaciones, con base en el temario y el calendario que usted proporciona.',
  'aet.review.footer': 'Creado con IA',
  'aet.footerCard.dismiss': 'Descartar',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'La preparación de estudio es una herramienta adicional que apoya el aprendizaje al proporcionarles a los estudiantes videos y problemas de práctica adaptados para este curso.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'A los estudiantes cuyo plan de acceso no incluya la preparación de estudio se les podría pedir que se suscriban para seguir utilizando los recursos de preparación de estudio.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'Los estudiantes que ya adquirieron preparación de estudio no se verán afectados por este ajuste.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'Vea más información sobre los beneficios de la preparación de estudio',
  'aet.home.viewCourseId': 'Ver identificador del curso',
  'aet.home.copy': 'Copiar',
  'aet.home.copied': 'Copiado',
  'aet.home.courseLabel': 'Identificador del curso:',
  'schoolInfoCard.addUniversity': 'Añadir escuela',
  'schoolInfoCard.title': 'Información de la escuela',
  'schoolInfoCard.titleV1': 'Cuéntenos sobre su curso',
  'schoolInfoCard.cta': 'Comenzar',
  'schoolInfoCard.pickInstitution': 'Elegir escuela',
  'schoolInfoCard.addUniversityTitle': 'Añada su escuela',
  'schoolInfoCard.addUniversitySubtitle': 'Conociendo su escuela y curso, permita que le recomendemos los materiales de estudio más útiles.',
  'schoolInfoCard.searchPlaceholder': 'Buscando su escuela...',
  'schoolInfoCard.skip': 'Omitir este paso',
  'schoolInfoCard.nextStep': 'Siguiente paso',
  'schoolInfoCard.notInList': 'Mi escuela no aparece en la lista.',
  'schoolInfoCard.noResults': 'No se encontraron escuelas que coincidan con su búsqueda',
  'schoolInfoCard.noResultsHeading': '¿No encuentra su escuela?',
  'schoolInfoCard.noResultsInstruction': 'Escriba el nombre completo a continuación',
  'schoolInfoCard.noResultsInputPlaceholder': 'Nombre de la escuela',
  'schoolInfoCard.addInstitutionLabel': 'Añadir esta escuela',
  'aet.assignments.assignmentTitlePlaceholder': 'Escriba un título',
  'aet.assignments.titleValidation.titleRequired': 'El título de la asignación es obligatorio.',
  'aet.assignments.titleValidation.titleTooLong': 'El título de la asignación no puede exceder de {0} caracteres.',
  'aet.assignments.titleValidation.titleInvalidChar': 'El título de la asignación contiene caracteres no admitidos.',
  'aet.assignments.titleValidation.titleDuplicate': 'El título de la asignación ya existe',
  'aet.syllabus.timeZoneLabel': 'Huso horario',
  'aet.review.reviewReadingFromAssignments': 'Revisar la lectura de la tarea',
  'aet.assignments.chaptersLabel': 'capítulo(s)',
  'menu.myAccount.subTitle': 'Su institución se aloja aquí',
  'menu.myAccount.subTitleNotAvailable': 'Puede añadir la institución aquí en cualquier momento.',
  'schoolInfoCard.toastMessage': 'Universidad guardada',
  'aet.review.threeDotMenu.askAI': 'Preguntarle a la IA',
  'aet.home.suggestedRemediationSubtitle': 'Vea videos pertinentes y practique para dominar los temas de su curso.',
  'aet.home.laggedQuestionLabel': 'Preguntas marcadas',
  'aet.home.correctAnswer': 'Respuesta correcta',
  'aet.home.incorrectAnswer': 'Respuesta incorrecta más común',
  'aet.home.behaviourTrendsLabel': 'Ideas sobre la pregunta',
  'aet.home.strugglingStudentsLabel': 'Estudiantes con dificultades',
  'aet.home.patternsInStudensAiLabel': 'Patrones en el uso de IA de los estudiantes',
  'aet.home.questionLabel': 'Pregunta',
  'aet.home.studentAskingSimilarQuestions': 'Estudiantes que hicieron preguntas similares:',
  'aet.home.assignmentDifficultQuestions': 'Preguntas difíciles',
  'aet.home.behaviorTrends': 'Ideas sobre la pregunta',
  'aet.home.behaviors': 'Indicadores de desempeño',
  'aet.home.mostDifficultTopics': 'Preguntas más difíciles',
  'aet.home.commentsFromStudentLabel': 'Comentarios de los estudiantes',
  'aet.home.disregard': 'Ignorar',
  'aet.home.reportAsInaccurate': 'Reportar como erróneo',
  'aet.home.Flagged': 'Marcado',
  'aet.home.reportQuestionTitle': 'Reportar pregunta',
  'aet.home.reportQuestionLabel': '¿Qué estaba mal en esta pregunta?',
  'aet.home.showComments': 'Mostrar comentarios',
  'aet.home.studentReports': 'informes del estudiante',
  'aet.home.placeholderText': 'Por favor explique...',
  'aet.home.reportQuestion.notRelevant': 'No es pertinente',
  'aet.home.reportQuestion.notCorrect': 'La información no es correcta',
  'aet.home.reportQuestion.unsafe': 'Inseguro o nocivo',
  'aet.home.reportQuestion.somethingElse': 'Algo más',
  'aet.home.StudentDetails.assistedByAI': 'Con asistencia de IA',
  'aet.home.strugglingStudents.emptyStateTitle': 'Ningún estudiante tiene dificultades ahora',
  'aet.home.strugglingStudents.emptyStateDescription': 'Vuelva a consultar más tarde.',
  'aet.home.overallStatus.excelling': 'Sobresaliente',
  'aet.home.overallStatus.fallingBehind': 'Rezagado',
  'aet.home.overallStatus.keepingUp': 'Al corriente',
  'aet.home.showOnlyDifficultQuestionsLabel': 'Mostrar solo "Preguntas difíciles"',
  'aet.home.showOnlyStrugglingStudentsLabel': 'Mostrar solo "Estudiantes con dificultades"',
  'aet.home.viewQuestionInAssignment': 'Ver pregunta en la asignación',
  'aet.home.insightRisk.incorrectFirstAttempts': 'Primeros intentos incorrectos',
  'aet.home.insightRisk.multipleIncorrectAttempts': 'Varios intentos incorrectos',
  'aet.home.insightRisk.lowConfidence': 'Confianza baja',
  'aet.home.insightRisk.mediumConfidence': 'Confianza media',
  'aet.home.insightRisk.lowEngagement': 'Participación baja',
  'aet.home.insightRisk.countOfStudents': '{count} de {total} estudiantes',
  'aet.home.insightRisk.na': 'N/A',
  'aet.home.strugglingStudentsHereLabel': 'Estudiantes que tienen dificultades aquí',
  'aet.home.insightRisk.didNotAttempt': 'No intentó',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText'
};

export default esmx;
